export const API_URL = 'https://stage-api.pmxchange.net/v1/';
//export const API_URL = "https://localhost:5009/api/";
// export const API_URL = "https://localhost:5009/api/";
//lotfan const bala pak nashavad
export const SERVER_URL = 'https://stage-api.pmxchange.net/';
export const VERSION = '1.0.15';
export const TinyEditorAPIKey = 'kbejtjil91dnjqm8a0fcd4aqyhm6feugw0mtlog40wvmhc03';
export const WEBSITE_URL = 'https://pmxchangeshop.com/';
export const SENTRY_DSN = 'https://309f00aa19e7eea7449bc12b627adde1@sentry.dev.pmxchange.net/6'